import React, { Fragment } from 'react';
import { connect } from 'react-redux';

import { createStyles, Theme, withStyles } from '@material-ui/core/styles';
import { Paper, Tooltip } from '@material-ui/core';

import style from '../awbReturn.module.css';
import commonStyles from '../../../common/common.module.css';
import AddBoxRounded from '@material-ui/icons/AddBoxRounded';
import CartItem from '../../../../models/CartItem';
import MaterialTable from 'material-table';
import CartService from '../../../../models/CartService';
import { getAdditionalServiceName } from '../../../../utils/additionalServices';
import { formatCurrency } from '../../../../utils/currencyFormatter';

const styles = (theme: Theme) =>

  createStyles({
    formControlLabel: {
      marginRight: '2%',
      '& p': {
        fontSize: '14px'
      }
    },
    label: {
      color: 'rgb(9, 43, 74)'
    },
    dummyCol: {
      width: '50%'
    },
    totalText: {
      width: '25%', 
      textAlign: 'right',
      paddingRight: '10px'
    },
    totalDetails: {
      width: '25%',
    },
    totalWrapper: {
      display: 'flex',
      color: 'var(--primaryblue)',
      fontWeight: 'bold',
      fontSize: '15px',
    }
  });

interface ReturnChargesomponentProps {
  classes: any;
  handleOpenModal: (type: string) => void;
  cartItem: CartItem | undefined;
};

const returnChargesComponent = (props: ReturnChargesomponentProps) => {

  const { classes } = props;
  return (
    <Fragment>
    <div className={ `${ commonStyles.wrapper }` }>
      
     <div className={ commonStyles.fSpaceBtw }>
      <h3 className={ commonStyles.header }> Charges</h3>
      <div>
        <Tooltip title="Add additional services">
          <AddBoxRounded className={ classes.addBox } color='primary' onClick={ () => props.handleOpenModal('addCharges') } />
        </Tooltip>
      </div>
     </div>
      <MaterialTable

        components={{ Container: props => <Paper {...props} elevation={0} className={`${commonStyles.paperTable} `} /> }}

        data={ props.cartItem ? props.cartItem.services : [] }
        
        localization = {{
          header: { actions: '' }
        }}
    
        columns={[
          { title: 'Fee', field: '', cellStyle: { width: '200px' , paddingRight: 0},
            render: (rowData: CartService) => { 
              if (rowData.type === 'other' || rowData.type === 'gha_adjust') {
                return (<span>{ getAdditionalServiceName(rowData.type) }: {rowData.params.reason}</span>); 
              }
              return (<span>{ getAdditionalServiceName(rowData.type) }</span>);
            }
          },
          { title: 'Paid', field: 'total', type:'currency', headerStyle: { paddingTop: '10px' }, cellStyle: { width: '110px', paddingRight: 0 } },
          { title: 'Due', field: 'remain', type:'currency', headerStyle: { paddingTop: '10px' }, cellStyle: { width: '110px', paddingRight: 0 } },
        
        ]}
        options={{
          selection: false,
          paging: false,
          actionsColumnIndex: -1,
          headerStyle: {
            backgroundColor: 'var(--tbl_head_bkg)',
            color: 'var(--tbl_head_color)',
            zIndex: 2
          },
          rowStyle: {
            height: '30px'
          },
          showTitle: false,
          toolbar: false,
          sorting: false
        }}
      />	
      <div className={ classes.totalWrapper }>
        <div className={ classes.dummyCol }></div>
        <div className={ classes.totalText }>Total:</div>
        <div className={ classes.totalDetails }>{ formatCurrency(props.cartItem ? props.cartItem.remainDue : 0, 2, '$') }</div>
      </div>
    </div>
  </Fragment>
  );
};

const mapStateToProps = (state: any) => {
  return {
    manualEntryEdit: state.manualEntryEdit,
    manualEntryAdd: state.manualEntryAdd
  };
}

export default withStyles(styles)(connect(mapStateToProps, {})(returnChargesComponent));
